// ── Catálogo pt-BR do pós-venda do Mercado Livre ─────────────────────────────
// TODAS as combinações documentadas de claims/mediações/devoluções (estudo
// 2026-08-18: doc oficial + 1.115 claims reais da conta). Fonte única de
// labels — lista, detalhe, chips e filtros importam daqui (CLAUDE.md §4).
// Valores fora do catálogo aparecem crus de propósito: é sinal de valor novo
// do ML que precisa entrar aqui, não de erro silencioso.

/** Tipo do claim (o processo que o comprador abriu). */
export const ML_CLAIM_TYPE_LABELS = {
    mediations: 'Reclamação',
    return: 'Devolução',
    returns: 'Devolução',
    fulfillment: 'Reclamação Full',
    ml_case: 'Caso do ML',
    cancel_purchase: 'Cancelamento de compra',
    cancel_sale: 'Cancelamento de venda',
    change: 'Troca',
    service: 'Serviço',
};

/** Etapa do claim (onde a briga está). */
export const ML_CLAIM_STAGE_LABELS = {
    claim: 'Reclamação (entre as partes)',
    dispute: 'Mediação (com o ML)',
    recontact: 'Recontato (caso reaberto)',
    none: 'Sem etapa (cancelamento)',
    stale: 'Inativo (sem movimentação)',
};

export const ML_CLAIM_STATUS_LABELS = {
    opened: 'Aberto',
    closed: 'Encerrado',
};

/**
 * Motivo do encerramento (resolution.reason) — catálogo completo da doc +
 * variantes vistas na prática (return_cancelled com LL, item_changed…).
 */
export const ML_RESOLUTION_REASON_LABELS = {
    already_shipped: 'produto já havia sido enviado',
    buyer_claim_opened: 'comprador abriu reclamação',
    buyer_dispute_opened: 'comprador escalou para mediação',
    cancel_installation: 'instalação cancelada',
    change_cancelled_buyer: 'troca cancelada pelo comprador',
    change_cancelled_meli: 'troca cancelada pelo ML',
    change_cancelled_seller: 'troca cancelada por nós',
    change_expired: 'troca expirada',
    charged_back: 'estorno no cartão (chargeback)',
    coverage_decision: 'ML cobriu o caso (dinheiro do ML)',
    found_missing_parts: 'peças faltantes localizadas',
    item_changed: 'produto trocado',
    item_returned: 'produto devolvido ao vendedor',
    low_cost: 'devolução dispensada (baixo custo)',
    no_bpp: 'sem cobertura do ML (compra não protegida)',
    not_delivered: 'pacote não entregue ao comprador',
    opened_claim_by_mistake: 'comprador abriu por engano',
    other: 'outro motivo',
    partial_refunded: 'reembolso parcial',
    payment_refunded: 'reembolso efetuado',
    prefered_to_keep_product: 'comprador preferiu ficar com o produto',
    product_delivered: 'produto entregue ao comprador',
    refunded: 'reembolso efetuado',
    reimbursed: 'reembolsado',
    rep_resolution: 'resolvido pelo atendimento do ML',
    respondent_timeout: 'vendedor não respondeu no prazo',
    return_canceled: 'devolução cancelada',
    return_cancelled: 'devolução cancelada',
    return_expired: 'comprador não postou no prazo',
    seller_asked_to_close_claim: 'vendedor pediu o encerramento',
    seller_did_not_help: 'vendedor não ajudou (registro contra a reputação)',
    seller_explained_functions: 'vendedor explicou o funcionamento',
    seller_sent_product: 'vendedor reenviou o produto',
    shipment_not_stopped: 'não foi possível parar o envio',
    timeout: 'encerrado por prazo',
    worked_out_with_seller: 'resolvido diretamente com o vendedor',
    warehouse_decision: 'decidido no armazém do ML',
    warehouse_timeout: 'armazém do ML não avaliou no prazo',
};

/** Ações que o ML disponibiliza aos players (available_actions). */
export const ML_ACTION_LABELS = {
    add_shipping_evidence: 'anexar evidência de envio',
    allow_partial_refund: 'oferecer reembolso parcial',
    allow_replace: 'oferecer reposição',
    allow_return: 'aceitar devolução',
    allow_return_label: 'gerar etiqueta de devolução',
    dispute_document: 'enviar documento da mediação',
    generate_return: 'gerar devolução',
    open_claim: 'abrir reclamação',
    open_dispute: 'abrir mediação',
    recontact: 'responder recontato',
    refund: 'reembolsar',
    return_review: 'revisar produto devolvido',
    return_review_fail: 'reprovar produto devolvido',
    return_review_ok: 'aprovar produto devolvido',
    return_review_unified_fail: 'reprovar produto devolvido',
    return_review_unified_ok: 'aprovar produto devolvido',
    send_attachments: 'enviar evidências (anexos)',
    send_message_to_complainant: 'responder ao comprador',
    send_message_to_mediator: 'responder ao mediador',
    send_message_to_respondent: 'mensagem ao vendedor',
    send_potential_fraud: 'reportar possível fraude',
    send_potential_shipping: 'informar envio potencial',
    send_tracking_number: 'informar rastreio',
};

/** Motivo da triagem/revisão no armazém do ML (reviews.reason_id). */
export const ML_REVIEW_REASON_LABELS = {
    accepted: 'produto aceito',
    blocked: 'produto bloqueado',
    default: 'sem classificação',
    different_product: 'produto diferente do vendido',
    discard: 'para descarte',
    incomplete: 'produto incompleto',
    missing: 'produto faltando',
    misused: 'produto com sinais de uso',
    not_working: 'produto não funciona',
    open_box: 'caixa aberta',
};

/** Motivo da NOSSA reprovação na revisão (seller_reason SRF*). */
export const ML_SELLER_REVIEW_REASON_LABELS = {
    SRF2: 'produto diferente do enviado',
    SRF3: 'produto com sinais de uso',
    SRF4: 'produto danificado',
    SRF5: 'produto incompleto (faltam peças)',
    SRF6: 'caixa vazia / produto ausente',
    SRF7: 'outro problema na devolução',
};

/** Penalização do comprador em devolução parcial (benefited_reason). */
export const ML_REVIEW_PENALTY_LABELS = {
    penalty_high: 'penalização alta ao comprador',
    penalty_low: 'penalização leve ao comprador',
    penalty_mid: 'penalização média ao comprador',
};

/** Status da devolução (nível do RETURN — o que o painel do ML mostra). */
export const ML_RETURN_STATUS_LABELS = {
    cancelled: 'devolução cancelada',
    closed: 'devolução encerrada',
    delivered: 'entregue',
    expired: 'expirada (não postada no prazo)',
    failed: 'falhou',
    label_generated: 'etiqueta gerada',
    not_delivered: 'não foi possível entregar',
    opened: 'devolução aberta',
    pending: 'aguardando postagem',
    pending_cancel: 'cancelamento em andamento',
    pending_delivered: 'entrega em confirmação',
    pending_expiration: 'prazo de postagem vencendo',
    pending_failure: 'falha em confirmação',
    ready_to_ship: 'pronto para postar',
    return_to_buyer: 'voltando ao comprador',
    scheduled: 'coleta agendada',
    shipped: 'a caminho',
    to_be_agreed: 'a combinar',
};

/** Situação do dinheiro da venda durante a devolução (status_money). */
export const ML_STATUS_MONEY_LABELS = {
    available: 'dinheiro liberado para nós',
    refunded: 'reembolsado ao comprador',
    retained: 'dinheiro retido pelo ML',
};

/** Destino físico da devolução. */
export const ML_DESTINATION_LABELS = {
    seller_address: 'nosso galpão',
    warehouse: 'armazém do ML',
};

/** Quem encerrou o caso (resolution.closed_by). */
export const ML_CLOSED_BY_LABELS = {
    buyer: 'comprador',
    complainant: 'comprador',
    mediator: 'Mercado Livre',
    respondent: 'nossa equipe',
    seller: 'nossa equipe',
};

/** Quem levou a melhor no encerramento (resolution.benefited). */
export const ML_BENEFITED_LABELS = {
    both: 'ambos',
    buyer: 'comprador',
    complainant: 'comprador',
    respondent: 'nossa equipe',
    seller: 'nossa equipe',
};

export const ML_AFFECTS_REPUTATION_LABELS = {
    affected: 'afeta a reputação',
    not_affected: 'não afeta a reputação',
    not_applies: 'não se aplica à reputação',
};

// ── Revisão de devolução (returns/reviews) ───────────────────────────────────

/** Etapa da revisão do produto devolvido. */
export const ML_REVIEW_STAGE_LABELS = {
    closed: 'revisão encerrada',
    pending: 'revisão pendente',
    seller_review_pending: 'aguardando nossa revisão',
    timeout: 'revisão expirada (sem resposta)',
};

/** Nosso veredito na revisão (seller_status). */
export const ML_REVIEW_SELLER_STATUS_LABELS = {
    claimed: 'contestamos a devolução',
    failed: 'reprovamos o produto',
    pending: 'aguardando nossa revisão',
    success: 'aprovamos o produto',
};

/** Condição do produto apurada na revisão/triagem. */
export const ML_PRODUCT_CONDITION_LABELS = {
    discard: 'para descarte',
    missing: 'produto faltando',
    saleable: 'apto para revenda',
    unsaleable: 'sem condição de revenda',
};

/** Para onde o produto vai após a revisão/triagem. */
export const ML_PRODUCT_DESTINATION_LABELS = {
    buyer: 'volta ao comprador',
    meli: 'fica com o ML',
    seller: 'vem para nós',
};

/** Como a devolução foi revisada. */
export const ML_REVIEW_METHOD_LABELS = {
    none: 'sem triagem (veio direto)',
    triage: 'triagem no armazém do ML',
};

// ── Envio/venda (rotulagem de campos crus exibidos no detalhe) ───────────────

export const ML_SHIPPING_STATUS_LABELS = {
    cancelled: 'cancelado',
    delivered: 'entregue',
    handling: 'em preparação',
    not_delivered: 'não entregue',
    pending: 'pendente',
    ready_to_ship: 'pronto para envio',
    returned: 'devolvido ao vendedor',
    shipped: 'a caminho',
    to_be_agreed: 'a combinar',
};

/**
 * Substatus do envio (`shipments.substatus` / histórico do envio) — os que a
 * base já mostrou (printed, in_warehouse, ready_for_pickup, in_packing_list,
 * ready_to_pack, invoice_pending, packed, buffered, out_for_delivery,
 * first_visit, pack_splitted) + os comuns da doc do ML (entrega, retirada,
 * atraso, devolução ao remetente). Fora do mapa: valor cru (`MlLabel`).
 */
export const ML_SHIPPING_SUBSTATUS_LABELS = {
    // pending / handling
    buffered: 'em espera no ML',
    cost_exceeded: 'custo de envio excedido',
    creating_route: 'criando rota',
    fraudulent: 'suspeita de fraude',
    invoice_pending: 'aguardando NF',
    manufacturing: 'em fabricação',
    regenerating: 'etiqueta sendo regerada',
    shipment_paid: 'envio pago',
    under_review: 'em análise',
    waiting_for_label_generation: 'aguardando geração da etiqueta',
    waiting_for_payment: 'aguardando pagamento',
    // ready_to_ship
    authorized_by_carrier: 'autorizado pela transportadora',
    dropped_off: 'postado na agência',
    in_hub: 'no centro de distribuição',
    in_packing_list: 'na lista de separação',
    in_pickup_list: 'na lista de coleta',
    in_warehouse: 'no armazém',
    measures_ready: 'medidas conferidas',
    on_hold: 'retido',
    packed: 'embalado',
    picked_up: 'coletado',
    printed: 'etiqueta impressa',
    ready_for_dropoff: 'pronto para postar na agência',
    ready_for_pickup: 'pronto para coleta',
    ready_for_pkl_creation: 'pronto para a lista de separação',
    ready_to_pack: 'pronto para embalar',
    ready_to_print: 'etiqueta pronta para imprimir',
    rejected_in_hub: 'recusado no centro de distribuição',
    waiting_for_carrier_authorization: 'aguardando autorização da transportadora',
    // shipped
    at_the_door: 'na porta do comprador',
    bad_address: 'endereço incorreto',
    contact_with_carrier_required: 'comprador precisa falar com a transportadora',
    delayed: 'atrasado',
    delivery_failed: 'falha na entrega',
    first_visit: 'primeira tentativa de entrega',
    forwarded_to_third: 'repassado a terceiros',
    in_transit: 'em trânsito',
    not_localized: 'não localizado',
    not_visited: 'endereço não visitado',
    out_for_delivery: 'saiu para entrega',
    receiver_absent: 'destinatário ausente',
    reclaimed: 'reclamado pelo comprador',
    refused_delivery: 'entrega recusada',
    retained: 'retido',
    returning_to_hub: 'voltando ao centro de distribuição',
    returning_to_sender: 'voltando ao vendedor',
    soon_deliver: 'entrega em breve',
    waiting_for_withdrawal: 'aguardando retirada',
    // delivered / not_delivered / cancelled
    confiscated: 'apreendido',
    damaged: 'danificado',
    destroyed: 'destruído',
    fulfilled_feedback: 'entrega confirmada pelo comprador',
    inferred: 'entrega presumida',
    label_expired: 'etiqueta vencida',
    lost: 'extraviado',
    pack_splitted: 'pacote dividido',
    recovered: 'recuperado',
    return_expired: 'devolução expirada',
    return_failed: 'devolução falhou',
    returned: 'devolvido',
    returned_to_hub: 'devolvido ao centro de distribuição',
    returned_to_warehouse: 'devolvido ao armazém',
    stolen: 'roubado',
    to_review: 'em revisão',
    waiting_for_return: 'aguardando devolução',
};

export const ML_LOGISTIC_TYPE_LABELS = {
    cross_docking: 'Coleta (cross docking)',
    drop_off: 'Agência (drop off)',
    fulfillment: 'Full',
    self_service: 'Flex',
    xd_drop_off: 'Agência (XD)',
};

export const MP_MONEY_RELEASE_LABELS = {
    pending: 'repasse pendente',
    released: 'repasse liberado',
};

export const ML_INVOICE_STATUS_LABELS = {
    authorized: 'autorizada',
    cancelled: 'cancelada',
    denied: 'denegada',
    pending: 'pendente',
    rejected: 'rejeitada',
};

/**
 * Label com fallback CRU (valor novo do ML aparece como veio — sinal para
 * atualizar o catálogo, nunca erro silencioso). Null/vazio vira '—'.
 */
export function MlLabel(map, value, blank = '—') {
    if (value === null || value === undefined || value === '') {
        return blank;
    }
    return map[value] || String(value);
}
